import { Type } from "@shared/ui/Type";
import OuterContentContainer from "@shared/ui/OuterContentContainer";
import MarketingContact from "../components/MarketingContact/MarketingContact";

export function ContactPage() {
  return (
    <OuterContentContainer
      className="flex-1 flex flex-col items-center justify-center"
      innerClassName="flex-1 gap-8 py-8 md:py-0"
    >
      <Type as="h1" variant="h2">
        Contact Us
      </Type>

      <MarketingContact />
    </OuterContentContainer>
  );
}

export default ContactPage;
